var An = Object.defineProperty;
var In = (e, t, n) => t in e ? An(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var dt = (e, t, n) => In(e, typeof t != "symbol" ? t + "" : t, n);
import * as pt from "react";
import ne, { useReducer as Tn, useRef as me, useMemo as Ae, useCallback as K, useEffect as ce, forwardRef as qt, useState as ae, Fragment as jn, createContext as Cn, PureComponent as Nn } from "react";
import { styled as oe, css as fe } from "styled-components";
import "react/jsx-runtime";
const Vt = {
  error: void 0,
  response: void 0,
  isLoading: !1,
  state: "idle"
}, Mn = (e, t) => {
  var n;
  switch (t.type) {
    case "loading":
      return {
        ...e,
        response: (n = t.meta) != null && n.isStale ? e.response : void 0,
        error: void 0,
        isLoading: !0,
        state: "loading"
      };
    case "fetched":
      return {
        ...e,
        response: t.payload,
        isLoading: !1,
        state: "success"
      };
    case "error":
      return {
        ...e,
        error: t.payload,
        isLoading: !1,
        state: "error"
      };
    case "abort":
      return {
        ...e,
        isLoading: !1,
        state: "aborted"
      };
    case "reset":
      return Vt;
    default:
      return e;
  }
}, kn = {
  isClean: !0,
  isCache: !0,
  isStale: !1,
  parseResponseOnError: !1,
  headers: { "Content-type": "application/json;charset=UTF-8" }
}, Dn = (e) => {
  const t = zt(e), [n, r] = Tn(
    Mn,
    Vt
  ), o = me({}), i = me(null), a = Ae(
    () => window.AbortController ? new window.AbortController() : void 0,
    []
  ), u = K(
    async (...E) => {
      var B;
      const {
        isClean: A,
        isCache: I,
        isStale: O,
        parseResponseOnError: D,
        adapter: N,
        ...G
      } = t, [C, R = {}] = E;
      if (!C) return;
      i.current = E, r({ type: "loading", meta: { isStale: O } });
      const g = o.current[C];
      if (g && mt(R))
        return r({ type: "fetched", payload: g }), g;
      try {
        const W = await fetch(C, {
          ...G,
          ...R,
          signal: a == null ? void 0 : a.signal
        });
        if (!W.ok) {
          if (D) {
            const H = await W.json();
            r({ type: "error", payload: H });
            return;
          }
          throw new Error(W.statusText);
        }
        if ((B = a == null ? void 0 : a.signal) != null && B.aborted) return;
        const Y = await W.json();
        let L = "data" in Y ? Y.data : Y;
        if (A) {
          const { decodeData: H } = await import("./decodeData-sQP2Fy6l.js");
          L = JSON.parse(H(JSON.stringify(L)));
        }
        return N && (L = N(L)), I && mt(R) && (o.current[C] = L), r({ type: "fetched", payload: L }), L;
      } catch (W) {
        if (Rn(W))
          return;
        r({ type: "error", payload: W });
      }
    },
    [a == null ? void 0 : a.signal, t]
  ), y = K(() => r({ type: "reset" }), []), p = K(
    (E) => {
      if (!i.current)
        return console.warn(
          "useFetch: fetch state wasn't initialized, make fetch before revalidate"
        ), Promise.resolve();
      const [A, I = {}] = i.current;
      return o.current[A] = void 0, u(A, { ...I, ...E });
    },
    [u, i]
  ), m = K(
    (...E) => {
      a == null || a.abort(...E), r({ type: "abort" });
    },
    [a]
  ), h = Ae(
    () => ({
      ...n,
      reset: y,
      revalidate: p,
      abort: m
    }),
    [m, y, p, n]
  );
  return ce(() => () => {
    m();
  }, [m]), [u, h];
};
function Co(e, t) {
  const n = zt(t), [r, o] = Dn(n);
  return ce(() => {
    e && r(e);
  }, [r, e]), o;
}
const zt = (e = {}) => {
  const {
    isCache: t,
    isClean: n,
    isStale: r,
    parseResponseOnError: o,
    body: i,
    method: a,
    mode: u,
    headers: y,
    keepalive: p,
    cache: m,
    credentials: h,
    window: E,
    redirect: A,
    integrity: I,
    referrerPolicy: O,
    signal: D,
    adapter: N
  } = { ...kn, ...e };
  return Ae(() => ({
    isCache: t,
    isClean: n,
    isStale: r,
    parseResponseOnError: o,
    body: i,
    method: a,
    mode: u,
    headers: y,
    keepalive: p,
    cache: m,
    credentials: h,
    window: E,
    redirect: A,
    integrity: I,
    referrerPolicy: O,
    signal: D,
    adapter: N
  }), [
    i,
    m,
    h,
    y,
    I,
    t,
    n,
    r,
    p,
    a,
    u,
    o,
    A,
    O,
    D,
    E,
    N
  ]);
}, Rn = (e) => {
  const t = e;
  return (t == null ? void 0 : t.name) === "AbortError";
}, mt = (e) => !e.method || e.method.toLocaleUpperCase() === "GET", $n = oe.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  min-height: 16px;
  font-size: 13px;
`;
oe.div`
  display: flex;
`;
oe.p`
  font-weight: 700;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
  margin: 0;
`;
oe.div`
  display: flex;
`;
oe($n)`
  margin-bottom: 0;
  margin-top: 8px;
  min-height: 1em;
  font-size: 16px;
`;
oe.div`
  display: flex;
  align-items: center;
`;
oe.p`
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0.1px;
  color: ${({ theme: e }) => e.colors.red50};
`;
fe`
  font-family: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;

  ${({ theme: { down: e } }) => e("tablet")} {
    font-size: 14px;
  }
`;
const Ut = "0px 1px 8px rgba(0, 0, 0, 0.17)", Wt = "0px 4px 20px rgba(0, 0, 0, 0.07)", Bt = "0px 4px 28px rgba(0, 0, 0, 0.14)";
fe`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${Ut});
`;
fe`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${Wt});
`;
fe`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${Bt});
`;
fe`
  box-shadow: ${Ut};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
fe`
  box-shadow: ${Wt};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
fe`
  box-shadow: ${Bt};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
const No = (e = !1) => {
  const [t, n] = ae(e), r = K(
    () => n((a) => !a),
    [n]
  ), o = K(() => n(!1), [n]), i = K(() => n(!0), [n]);
  return { isToggled: t, toggle: r, toggleFalse: o, toggleTrue: i };
}, Mo = (e, t) => {
  ce(() => {
    const n = (r) => {
      Array.isArray(e) && e.some(
        (o) => !o.current || o.current.contains((r == null ? void 0 : r.target) || null)
      ) || !Array.isArray(e) && (!e.current || e.current.contains((r == null ? void 0 : r.target) || null)) || t(r);
    };
    return document.addEventListener("mousedown", n), document.addEventListener("touchstart", n), () => {
      document.removeEventListener("mousedown", n), document.removeEventListener("touchstart", n);
    };
  }, [e, t]);
}, ko = () => {
  const [e, t] = ae({
    width: 0,
    height: 0
  });
  return ce(() => {
    const n = () => {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    return n(), window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, []), e;
};
function Ln(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
function be() {
  return be = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, be.apply(null, arguments);
}
function Gn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xe = { exports: {} }, Te = { exports: {} }, q = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vt;
function Fn() {
  if (vt) return q;
  vt = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, y = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, G = e ? Symbol.for("react.scope") : 60119;
  function C(g) {
    if (typeof g == "object" && g !== null) {
      var B = g.$$typeof;
      switch (B) {
        case t:
          switch (g = g.type, g) {
            case y:
            case p:
            case r:
            case i:
            case o:
            case h:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case u:
                case m:
                case I:
                case A:
                case a:
                  return g;
                default:
                  return B;
              }
          }
        case n:
          return B;
      }
    }
  }
  function R(g) {
    return C(g) === p;
  }
  return q.AsyncMode = y, q.ConcurrentMode = p, q.ContextConsumer = u, q.ContextProvider = a, q.Element = t, q.ForwardRef = m, q.Fragment = r, q.Lazy = I, q.Memo = A, q.Portal = n, q.Profiler = i, q.StrictMode = o, q.Suspense = h, q.isAsyncMode = function(g) {
    return R(g) || C(g) === y;
  }, q.isConcurrentMode = R, q.isContextConsumer = function(g) {
    return C(g) === u;
  }, q.isContextProvider = function(g) {
    return C(g) === a;
  }, q.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === t;
  }, q.isForwardRef = function(g) {
    return C(g) === m;
  }, q.isFragment = function(g) {
    return C(g) === r;
  }, q.isLazy = function(g) {
    return C(g) === I;
  }, q.isMemo = function(g) {
    return C(g) === A;
  }, q.isPortal = function(g) {
    return C(g) === n;
  }, q.isProfiler = function(g) {
    return C(g) === i;
  }, q.isStrictMode = function(g) {
    return C(g) === o;
  }, q.isSuspense = function(g) {
    return C(g) === h;
  }, q.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === r || g === p || g === i || g === o || g === h || g === E || typeof g == "object" && g !== null && (g.$$typeof === I || g.$$typeof === A || g.$$typeof === a || g.$$typeof === u || g.$$typeof === m || g.$$typeof === D || g.$$typeof === N || g.$$typeof === G || g.$$typeof === O);
  }, q.typeOf = C, q;
}
var V = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yt;
function qn() {
  return yt || (yt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, y = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, G = e ? Symbol.for("react.scope") : 60119;
    function C(w) {
      return typeof w == "string" || typeof w == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      w === r || w === p || w === i || w === o || w === h || w === E || typeof w == "object" && w !== null && (w.$$typeof === I || w.$$typeof === A || w.$$typeof === a || w.$$typeof === u || w.$$typeof === m || w.$$typeof === D || w.$$typeof === N || w.$$typeof === G || w.$$typeof === O);
    }
    function R(w) {
      if (typeof w == "object" && w !== null) {
        var Z = w.$$typeof;
        switch (Z) {
          case t:
            var le = w.type;
            switch (le) {
              case y:
              case p:
              case r:
              case i:
              case o:
              case h:
                return le;
              default:
                var _e = le && le.$$typeof;
                switch (_e) {
                  case u:
                  case m:
                  case I:
                  case A:
                  case a:
                    return _e;
                  default:
                    return Z;
                }
            }
          case n:
            return Z;
        }
      }
    }
    var g = y, B = p, W = u, Y = a, L = t, H = m, ee = r, J = I, re = A, d = n, c = i, s = o, l = h, b = !1;
    function S(w) {
      return b || (b = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), f(w) || R(w) === y;
    }
    function f(w) {
      return R(w) === p;
    }
    function v(w) {
      return R(w) === u;
    }
    function _(w) {
      return R(w) === a;
    }
    function P(w) {
      return typeof w == "object" && w !== null && w.$$typeof === t;
    }
    function x(w) {
      return R(w) === m;
    }
    function M(w) {
      return R(w) === r;
    }
    function j(w) {
      return R(w) === I;
    }
    function T(w) {
      return R(w) === A;
    }
    function k(w) {
      return R(w) === n;
    }
    function F(w) {
      return R(w) === i;
    }
    function $(w) {
      return R(w) === o;
    }
    function U(w) {
      return R(w) === h;
    }
    V.AsyncMode = g, V.ConcurrentMode = B, V.ContextConsumer = W, V.ContextProvider = Y, V.Element = L, V.ForwardRef = H, V.Fragment = ee, V.Lazy = J, V.Memo = re, V.Portal = d, V.Profiler = c, V.StrictMode = s, V.Suspense = l, V.isAsyncMode = S, V.isConcurrentMode = f, V.isContextConsumer = v, V.isContextProvider = _, V.isElement = P, V.isForwardRef = x, V.isFragment = M, V.isLazy = j, V.isMemo = T, V.isPortal = k, V.isProfiler = F, V.isStrictMode = $, V.isSuspense = U, V.isValidElementType = C, V.typeOf = R;
  }()), V;
}
var gt;
function Qt() {
  return gt || (gt = 1, process.env.NODE_ENV === "production" ? Te.exports = Fn() : Te.exports = qn()), Te.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var je, ht;
function Vn() {
  if (ht) return je;
  ht = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, u = 0; u < 10; u++)
        a["_" + String.fromCharCode(u)] = u;
      var y = Object.getOwnPropertyNames(a).map(function(m) {
        return a[m];
      });
      if (y.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return je = o() ? Object.assign : function(i, a) {
    for (var u, y = r(i), p, m = 1; m < arguments.length; m++) {
      u = Object(arguments[m]);
      for (var h in u)
        t.call(u, h) && (y[h] = u[h]);
      if (e) {
        p = e(u);
        for (var E = 0; E < p.length; E++)
          n.call(u, p[E]) && (y[p[E]] = u[p[E]]);
      }
    }
    return y;
  }, je;
}
var Ce, bt;
function Ke() {
  if (bt) return Ce;
  bt = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ce = e, Ce;
}
var wt, Et;
function Yt() {
  return Et || (Et = 1, wt = Function.call.bind(Object.prototype.hasOwnProperty)), wt;
}
var Ne, Ot;
function zn() {
  if (Ot) return Ne;
  Ot = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Ke(), n = {}, r = /* @__PURE__ */ Yt();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, u, y, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var m in i)
        if (r(i, m)) {
          var h;
          try {
            if (typeof i[m] != "function") {
              var E = Error(
                (y || "React class") + ": " + u + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw E.name = "Invariant Violation", E;
            }
            h = i[m](a, m, y, u, null, t);
          } catch (I) {
            h = I;
          }
          if (h && !(h instanceof Error) && e(
            (y || "React class") + ": type specification of " + u + " `" + m + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var A = p ? p() : "";
            e(
              "Failed " + u + " type: " + h.message + (A ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ne = o, Ne;
}
var Me, St;
function Un() {
  if (St) return Me;
  St = 1;
  var e = Qt(), t = Vn(), n = /* @__PURE__ */ Ke(), r = /* @__PURE__ */ Yt(), o = /* @__PURE__ */ zn(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(u) {
    var y = "Warning: " + u;
    typeof console < "u" && console.error(y);
    try {
      throw new Error(y);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Me = function(u, y) {
    var p = typeof Symbol == "function" && Symbol.iterator, m = "@@iterator";
    function h(f) {
      var v = f && (p && f[p] || f[m]);
      if (typeof v == "function")
        return v;
    }
    var E = "<<anonymous>>", A = {
      array: N("array"),
      bigint: N("bigint"),
      bool: N("boolean"),
      func: N("function"),
      number: N("number"),
      object: N("object"),
      string: N("string"),
      symbol: N("symbol"),
      any: G(),
      arrayOf: C,
      element: R(),
      elementType: g(),
      instanceOf: B,
      node: H(),
      objectOf: Y,
      oneOf: W,
      oneOfType: L,
      shape: J,
      exact: re
    };
    function I(f, v) {
      return f === v ? f !== 0 || 1 / f === 1 / v : f !== f && v !== v;
    }
    function O(f, v) {
      this.message = f, this.data = v && typeof v == "object" ? v : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function D(f) {
      if (process.env.NODE_ENV !== "production")
        var v = {}, _ = 0;
      function P(M, j, T, k, F, $, U) {
        if (k = k || E, $ = $ || T, U !== n) {
          if (y) {
            var w = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw w.name = "Invariant Violation", w;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Z = k + ":" + T;
            !v[Z] && // Avoid spamming the console because they are often not actionable except for lib authors
            _ < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + $ + "` prop on `" + k + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), v[Z] = !0, _++);
          }
        }
        return j[T] == null ? M ? j[T] === null ? new O("The " + F + " `" + $ + "` is marked as required " + ("in `" + k + "`, but its value is `null`.")) : new O("The " + F + " `" + $ + "` is marked as required in " + ("`" + k + "`, but its value is `undefined`.")) : null : f(j, T, k, F, $);
      }
      var x = P.bind(null, !1);
      return x.isRequired = P.bind(null, !0), x;
    }
    function N(f) {
      function v(_, P, x, M, j, T) {
        var k = _[P], F = s(k);
        if (F !== f) {
          var $ = l(k);
          return new O(
            "Invalid " + M + " `" + j + "` of type " + ("`" + $ + "` supplied to `" + x + "`, expected ") + ("`" + f + "`."),
            { expectedType: f }
          );
        }
        return null;
      }
      return D(v);
    }
    function G() {
      return D(a);
    }
    function C(f) {
      function v(_, P, x, M, j) {
        if (typeof f != "function")
          return new O("Property `" + j + "` of component `" + x + "` has invalid PropType notation inside arrayOf.");
        var T = _[P];
        if (!Array.isArray(T)) {
          var k = s(T);
          return new O("Invalid " + M + " `" + j + "` of type " + ("`" + k + "` supplied to `" + x + "`, expected an array."));
        }
        for (var F = 0; F < T.length; F++) {
          var $ = f(T, F, x, M, j + "[" + F + "]", n);
          if ($ instanceof Error)
            return $;
        }
        return null;
      }
      return D(v);
    }
    function R() {
      function f(v, _, P, x, M) {
        var j = v[_];
        if (!u(j)) {
          var T = s(j);
          return new O("Invalid " + x + " `" + M + "` of type " + ("`" + T + "` supplied to `" + P + "`, expected a single ReactElement."));
        }
        return null;
      }
      return D(f);
    }
    function g() {
      function f(v, _, P, x, M) {
        var j = v[_];
        if (!e.isValidElementType(j)) {
          var T = s(j);
          return new O("Invalid " + x + " `" + M + "` of type " + ("`" + T + "` supplied to `" + P + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return D(f);
    }
    function B(f) {
      function v(_, P, x, M, j) {
        if (!(_[P] instanceof f)) {
          var T = f.name || E, k = S(_[P]);
          return new O("Invalid " + M + " `" + j + "` of type " + ("`" + k + "` supplied to `" + x + "`, expected ") + ("instance of `" + T + "`."));
        }
        return null;
      }
      return D(v);
    }
    function W(f) {
      if (!Array.isArray(f))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function v(_, P, x, M, j) {
        for (var T = _[P], k = 0; k < f.length; k++)
          if (I(T, f[k]))
            return null;
        var F = JSON.stringify(f, function($, U) {
          var w = l(U);
          return w === "symbol" ? String(U) : U;
        });
        return new O("Invalid " + M + " `" + j + "` of value `" + String(T) + "` " + ("supplied to `" + x + "`, expected one of " + F + "."));
      }
      return D(v);
    }
    function Y(f) {
      function v(_, P, x, M, j) {
        if (typeof f != "function")
          return new O("Property `" + j + "` of component `" + x + "` has invalid PropType notation inside objectOf.");
        var T = _[P], k = s(T);
        if (k !== "object")
          return new O("Invalid " + M + " `" + j + "` of type " + ("`" + k + "` supplied to `" + x + "`, expected an object."));
        for (var F in T)
          if (r(T, F)) {
            var $ = f(T, F, x, M, j + "." + F, n);
            if ($ instanceof Error)
              return $;
          }
        return null;
      }
      return D(v);
    }
    function L(f) {
      if (!Array.isArray(f))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var v = 0; v < f.length; v++) {
        var _ = f[v];
        if (typeof _ != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + b(_) + " at index " + v + "."
          ), a;
      }
      function P(x, M, j, T, k) {
        for (var F = [], $ = 0; $ < f.length; $++) {
          var U = f[$], w = U(x, M, j, T, k, n);
          if (w == null)
            return null;
          w.data && r(w.data, "expectedType") && F.push(w.data.expectedType);
        }
        var Z = F.length > 0 ? ", expected one of type [" + F.join(", ") + "]" : "";
        return new O("Invalid " + T + " `" + k + "` supplied to " + ("`" + j + "`" + Z + "."));
      }
      return D(P);
    }
    function H() {
      function f(v, _, P, x, M) {
        return d(v[_]) ? null : new O("Invalid " + x + " `" + M + "` supplied to " + ("`" + P + "`, expected a ReactNode."));
      }
      return D(f);
    }
    function ee(f, v, _, P, x) {
      return new O(
        (f || "React class") + ": " + v + " type `" + _ + "." + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + x + "`."
      );
    }
    function J(f) {
      function v(_, P, x, M, j) {
        var T = _[P], k = s(T);
        if (k !== "object")
          return new O("Invalid " + M + " `" + j + "` of type `" + k + "` " + ("supplied to `" + x + "`, expected `object`."));
        for (var F in f) {
          var $ = f[F];
          if (typeof $ != "function")
            return ee(x, M, j, F, l($));
          var U = $(T, F, x, M, j + "." + F, n);
          if (U)
            return U;
        }
        return null;
      }
      return D(v);
    }
    function re(f) {
      function v(_, P, x, M, j) {
        var T = _[P], k = s(T);
        if (k !== "object")
          return new O("Invalid " + M + " `" + j + "` of type `" + k + "` " + ("supplied to `" + x + "`, expected `object`."));
        var F = t({}, _[P], f);
        for (var $ in F) {
          var U = f[$];
          if (r(f, $) && typeof U != "function")
            return ee(x, M, j, $, l(U));
          if (!U)
            return new O(
              "Invalid " + M + " `" + j + "` key `" + $ + "` supplied to `" + x + "`.\nBad object: " + JSON.stringify(_[P], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(f), null, "  ")
            );
          var w = U(T, $, x, M, j + "." + $, n);
          if (w)
            return w;
        }
        return null;
      }
      return D(v);
    }
    function d(f) {
      switch (typeof f) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !f;
        case "object":
          if (Array.isArray(f))
            return f.every(d);
          if (f === null || u(f))
            return !0;
          var v = h(f);
          if (v) {
            var _ = v.call(f), P;
            if (v !== f.entries) {
              for (; !(P = _.next()).done; )
                if (!d(P.value))
                  return !1;
            } else
              for (; !(P = _.next()).done; ) {
                var x = P.value;
                if (x && !d(x[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function c(f, v) {
      return f === "symbol" ? !0 : v ? v["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && v instanceof Symbol : !1;
    }
    function s(f) {
      var v = typeof f;
      return Array.isArray(f) ? "array" : f instanceof RegExp ? "object" : c(v, f) ? "symbol" : v;
    }
    function l(f) {
      if (typeof f > "u" || f === null)
        return "" + f;
      var v = s(f);
      if (v === "object") {
        if (f instanceof Date)
          return "date";
        if (f instanceof RegExp)
          return "regexp";
      }
      return v;
    }
    function b(f) {
      var v = l(f);
      switch (v) {
        case "array":
        case "object":
          return "an " + v;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + v;
        default:
          return v;
      }
    }
    function S(f) {
      return !f.constructor || !f.constructor.name ? E : f.constructor.name;
    }
    return A.checkPropTypes = o, A.resetWarningCache = o.resetWarningCache, A.PropTypes = A, A;
  }, Me;
}
var ke, _t;
function Wn() {
  if (_t) return ke;
  _t = 1;
  var e = /* @__PURE__ */ Ke();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, ke = function() {
    function r(a, u, y, p, m, h) {
      if (h !== e) {
        var E = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw E.name = "Invariant Violation", E;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, ke;
}
var xt;
function Bn() {
  if (xt) return xe.exports;
  if (xt = 1, process.env.NODE_ENV !== "production") {
    var e = Qt(), t = !0;
    xe.exports = /* @__PURE__ */ Un()(e.isElement, t);
  } else
    xe.exports = /* @__PURE__ */ Wn()();
  return xe.exports;
}
var z = /* @__PURE__ */ Bn();
const Ht = /* @__PURE__ */ Gn(z);
var Ue = "data-focus-lock", Kt = "data-focus-lock-disabled", Qn = "data-no-focus-lock", Yn = "data-autofocus-inside", Hn = "data-no-autofocus";
function De(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Kn(e, t) {
  var n = ae(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Jn = typeof window < "u" ? pt.useLayoutEffect : pt.useEffect, Pt = /* @__PURE__ */ new WeakMap();
function Zn(e, t) {
  var n = Kn(null, function(r) {
    return e.forEach(function(o) {
      return De(o, r);
    });
  });
  return Jn(function() {
    var r = Pt.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(u) {
        i.has(u) || De(u, null);
      }), i.forEach(function(u) {
        o.has(u) || De(u, a);
      });
    }
    Pt.set(n, e);
  }, [e]), n;
}
var Re = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && Ht.node;
var We = function() {
  return We = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, We.apply(this, arguments);
};
function Jt(e) {
  return e;
}
function Zt(e, t) {
  t === void 0 && (t = Jt);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(u) {
          return u !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(u) {
          return i(u);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var u = n;
        n = [], u.forEach(i), a = n;
      }
      var y = function() {
        var m = a;
        a = [], m.forEach(i);
      }, p = function() {
        return Promise.resolve().then(y);
      };
      p(), n = {
        push: function(m) {
          a.push(m), p();
        },
        filter: function(m) {
          return a = a.filter(m), n;
        }
      };
    }
  };
  return o;
}
function Je(e, t) {
  return t === void 0 && (t = Jt), Zt(e, t);
}
function Xn(e) {
  e === void 0 && (e = {});
  var t = Zt(null);
  return t.options = We({ async: !0, ssr: !1 }, e), t;
}
var Xt = Je({}, function(e) {
  var t = e.target, n = e.currentTarget;
  return {
    target: t,
    currentTarget: n
  };
}), en = Je(), er = Je(), tr = Xn({
  async: !0,
  ssr: typeof document < "u"
}), nr = /* @__PURE__ */ Cn(void 0), rr = [], Ze = /* @__PURE__ */ qt(function(e, t) {
  var n, r = ae(), o = r[0], i = r[1], a = me(), u = me(!1), y = me(null), p = ae({}), m = p[1], h = e.children, E = e.disabled, A = E === void 0 ? !1 : E, I = e.noFocusGuards, O = I === void 0 ? !1 : I, D = e.persistentFocus, N = D === void 0 ? !1 : D, G = e.crossFrame, C = G === void 0 ? !0 : G, R = e.autoFocus, g = R === void 0 ? !0 : R, B = e.allowTextSelection, W = e.group, Y = e.className, L = e.whiteList, H = e.hasPositiveIndices, ee = e.shards, J = ee === void 0 ? rr : ee, re = e.as, d = re === void 0 ? "div" : re, c = e.lockProps, s = c === void 0 ? {} : c, l = e.sideCar, b = e.returnFocus, S = b === void 0 ? !1 : b, f = e.focusOptions, v = e.onActivation, _ = e.onDeactivation, P = ae({}), x = P[0], M = K(function(te) {
    var de = te.captureFocusRestore;
    if (!y.current) {
      var pe, ie = (pe = document) == null ? void 0 : pe.activeElement;
      y.current = ie, ie !== document.body && (y.current = de(ie));
    }
    a.current && v && v(a.current), u.current = !0, m();
  }, [v]), j = K(function() {
    u.current = !1, _ && _(a.current), m();
  }, [_]), T = K(function(te) {
    var de = y.current;
    if (de) {
      var pe = (typeof de == "function" ? de() : de) || document.body, ie = typeof S == "function" ? S(pe) : S;
      if (ie) {
        var lt = typeof ie == "object" ? ie : void 0;
        y.current = null, te ? Promise.resolve().then(function() {
          return pe.focus(lt);
        }) : pe.focus(lt);
      }
    }
  }, [S]), k = K(function(te) {
    u.current && Xt.useMedium(te);
  }, []), F = en.useMedium, $ = K(function(te) {
    a.current !== te && (a.current = te, i(te));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof B < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), ce(function() {
    !a.current && typeof d != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var U = be((n = {}, n[Kt] = A && "disabled", n[Ue] = W, n), s), w = O !== !0, Z = w && O !== "tail", le = Zn([t, $]), _e = Ae(function() {
    return {
      observed: a,
      shards: J,
      enabled: !A,
      active: u.current
    };
  }, [A, u.current, J, o]);
  return /* @__PURE__ */ ne.createElement(jn, null, w && [
    /* @__PURE__ */ ne.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: A ? -1 : 0,
      style: Re
    }),
    H ? /* @__PURE__ */ ne.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: A ? -1 : 1,
      style: Re
    }) : null
  ], !A && /* @__PURE__ */ ne.createElement(l, {
    id: x,
    sideCar: tr,
    observed: o,
    disabled: A,
    persistentFocus: N,
    crossFrame: C,
    autoFocus: g,
    whiteList: L,
    shards: J,
    onActivation: M,
    onDeactivation: j,
    returnFocus: T,
    focusOptions: f,
    noFocusGuards: O
  }), /* @__PURE__ */ ne.createElement(d, be({
    ref: le
  }, U, {
    className: Y,
    onBlur: F,
    onFocus: k
  }), /* @__PURE__ */ ne.createElement(nr.Provider, {
    value: _e
  }, h)), Z && /* @__PURE__ */ ne.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: A ? -1 : 0,
    style: Re
  }));
});
Ze.propTypes = process.env.NODE_ENV !== "production" ? {
  children: z.node,
  disabled: z.bool,
  returnFocus: z.oneOfType([z.bool, z.object, z.func]),
  focusOptions: z.object,
  noFocusGuards: z.bool,
  hasPositiveIndices: z.bool,
  allowTextSelection: z.bool,
  autoFocus: z.bool,
  persistentFocus: z.bool,
  crossFrame: z.bool,
  group: z.string,
  className: z.string,
  whiteList: z.func,
  shards: z.arrayOf(z.any),
  as: z.oneOfType([z.string, z.func, z.object]),
  lockProps: z.object,
  onActivation: z.func,
  onDeactivation: z.func,
  sideCar: z.any.isRequired
} : {};
function Be(e, t) {
  return Be = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Be(e, t);
}
function or(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Be(e, t);
}
function we(e) {
  "@babel/helpers - typeof";
  return we = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, we(e);
}
function ir(e, t) {
  if (we(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (we(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ar(e) {
  var t = ir(e, "string");
  return we(t) == "symbol" ? t : t + "";
}
function ur(e, t, n) {
  return (t = ar(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function cr(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof t != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function n(r) {
    return r.displayName || r.name || "Component";
  }
  return function(r) {
    if (process.env.NODE_ENV !== "production" && typeof r != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var o = [], i;
    function a() {
      i = e(o.map(function(y) {
        return y.props;
      })), t(i);
    }
    var u = /* @__PURE__ */ function(y) {
      or(p, y);
      function p() {
        return y.apply(this, arguments) || this;
      }
      p.peek = function() {
        return i;
      };
      var m = p.prototype;
      return m.componentDidMount = function() {
        o.push(this), a();
      }, m.componentDidUpdate = function() {
        a();
      }, m.componentWillUnmount = function() {
        var h = o.indexOf(this);
        o.splice(h, 1), a();
      }, m.render = function() {
        return /* @__PURE__ */ ne.createElement(r, this.props);
      }, p;
    }(Nn);
    return ur(u, "displayName", "SideEffect(" + n(r) + ")"), u;
  };
}
var X = function(e) {
  for (var t = Array(e.length), n = 0; n < e.length; ++n)
    t[n] = e[n];
  return t;
}, se = function(e) {
  return Array.isArray(e) ? e : [e];
}, tn = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, sr = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var t = window.getComputedStyle(e, null);
  return !t || !t.getPropertyValue ? !1 : t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}, nn = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, rn = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, fr = function(e) {
  return e.hasAttribute("inert");
}, lr = function(e, t) {
  return !e || rn(e) || !sr(e) && !fr(e) && t(nn(e));
}, on = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = lr(t, on.bind(void 0, e));
  return e.set(t, r), r;
}, dr = function(e, t) {
  return e && !rn(e) ? vr(e) ? t(nn(e)) : !1 : !0;
}, an = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = dr(t, an.bind(void 0, e));
  return e.set(t, r), r;
}, un = function(e) {
  return e.dataset;
}, pr = function(e) {
  return e.tagName === "BUTTON";
}, cn = function(e) {
  return e.tagName === "INPUT";
}, sn = function(e) {
  return cn(e) && e.type === "radio";
}, mr = function(e) {
  return !((cn(e) || pr(e)) && (e.type === "hidden" || e.disabled));
}, vr = function(e) {
  var t = e.getAttribute(Hn);
  return ![!0, "true", ""].includes(t);
}, Xe = function(e) {
  var t;
  return !!(e && !((t = un(e)) === null || t === void 0) && t.focusGuard);
}, Qe = function(e) {
  return !Xe(e);
}, yr = function(e) {
  return !!e;
}, gr = function(e, t) {
  var n = Math.max(0, e.tabIndex), r = Math.max(0, t.tabIndex), o = n - r, i = e.index - t.index;
  if (o) {
    if (!n)
      return 1;
    if (!r)
      return -1;
  }
  return o || i;
}, hr = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, et = function(e, t, n) {
  return X(e).map(function(r, o) {
    var i = hr(r);
    return {
      node: r,
      index: o,
      tabIndex: n && i === -1 ? (r.dataset || {}).focusGuard ? 0 : -1 : i
    };
  }).filter(function(r) {
    return !t || r.tabIndex >= 0;
  }).sort(gr);
}, br = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], tt = br.join(","), wr = "".concat(tt, ", [data-focus-guard]"), fn = function(e, t) {
  return X((e.shadowRoot || e).children).reduce(function(n, r) {
    return n.concat(r.matches(t ? wr : tt) ? [r] : [], fn(r));
  }, []);
}, Er = function(e, t) {
  var n;
  return e instanceof HTMLIFrameElement && !((n = e.contentDocument) === null || n === void 0) && n.body ? ge([e.contentDocument.body], t) : [e];
}, ge = function(e, t) {
  return e.reduce(function(n, r) {
    var o, i = fn(r, t), a = (o = []).concat.apply(o, i.map(function(u) {
      return Er(u, t);
    }));
    return n.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      a,
      // add if node is tabbable itself
      r.parentNode ? X(r.parentNode.querySelectorAll(tt)).filter(function(u) {
        return u === r;
      }) : []
    );
  }, []);
}, Or = function(e) {
  var t = e.querySelectorAll("[".concat(Yn, "]"));
  return X(t).map(function(n) {
    return ge([n]);
  }).reduce(function(n, r) {
    return n.concat(r);
  }, []);
}, nt = function(e, t) {
  return X(e).filter(function(n) {
    return on(t, n);
  }).filter(function(n) {
    return mr(n);
  });
}, At = function(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ new Map()), X(e).filter(function(n) {
    return an(t, n);
  });
}, rt = function(e, t, n) {
  return et(nt(ge(e, n), t), !0, n);
}, Ee = function(e, t) {
  return et(nt(ge(e), t), !1);
}, Sr = function(e, t) {
  return nt(Or(e), t);
}, ue = function(e, t) {
  return e.shadowRoot ? ue(e.shadowRoot, t) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, t) ? !0 : X(e.children).some(function(n) {
    var r;
    if (n instanceof HTMLIFrameElement) {
      var o = (r = n.contentDocument) === null || r === void 0 ? void 0 : r.body;
      return o ? ue(o, t) : !1;
    }
    return ue(n, t);
  });
}, _r = function(e) {
  for (var t = /* @__PURE__ */ new Set(), n = e.length, r = 0; r < n; r += 1)
    for (var o = r + 1; o < n; o += 1) {
      var i = e[r].compareDocumentPosition(e[o]);
      (i & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(o), (i & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(r);
    }
  return e.filter(function(a, u) {
    return !t.has(u);
  });
}, ln = function(e) {
  return e.parentNode ? ln(e.parentNode) : e;
}, ot = function(e) {
  var t = se(e);
  return t.filter(Boolean).reduce(function(n, r) {
    var o = r.getAttribute(Ue);
    return n.push.apply(n, o ? _r(X(ln(r).querySelectorAll("[".concat(Ue, '="').concat(o, '"]:not([').concat(Kt, '="disabled"])')))) : [r]), n;
  }, []);
}, xr = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, Oe = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var t = e.activeElement;
    return t.shadowRoot ? Oe(t.shadowRoot) : t instanceof HTMLIFrameElement && xr(function() {
      return t.contentWindow.document;
    }) ? Oe(t.contentWindow.document) : t;
  }
}, Pr = function(e, t) {
  return e === t;
}, Ar = function(e, t) {
  return !!X(e.querySelectorAll("iframe")).some(function(n) {
    return Pr(n, t);
  });
}, dn = function(e, t) {
  return t === void 0 && (t = Oe(tn(e).ownerDocument)), !t || t.dataset && t.dataset.focusGuard ? !1 : ot(e).some(function(n) {
    return ue(n, t) || Ar(n, t);
  });
}, Ir = function(e) {
  e === void 0 && (e = document);
  var t = Oe(e);
  return t ? X(e.querySelectorAll("[".concat(Qn, "]"))).some(function(n) {
    return ue(n, t);
  }) : !1;
}, Tr = function(e, t) {
  return t.filter(sn).filter(function(n) {
    return n.name === e.name;
  }).filter(function(n) {
    return n.checked;
  })[0] || e;
}, it = function(e, t) {
  return sn(e) && e.name ? Tr(e, t) : e;
}, jr = function(e) {
  var t = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return t.add(it(n, e));
  }), e.filter(function(n) {
    return t.has(n);
  });
}, It = function(e) {
  return e[0] && e.length > 1 ? it(e[0], e) : e[0];
}, Tt = function(e, t) {
  return e.indexOf(it(t, e));
}, Ye = "NEW_FOCUS", Cr = function(e, t, n, r, o) {
  var i = e.length, a = e[0], u = e[i - 1], y = Xe(r);
  if (!(r && e.indexOf(r) >= 0)) {
    var p = r !== void 0 ? n.indexOf(r) : -1, m = o ? n.indexOf(o) : p, h = o ? e.indexOf(o) : -1;
    if (p === -1)
      return h !== -1 ? h : Ye;
    if (h === -1)
      return Ye;
    var E = p - m, A = n.indexOf(a), I = n.indexOf(u), O = jr(n), D = r !== void 0 ? O.indexOf(r) : -1, N = o ? O.indexOf(o) : D, G = O.filter(function(Y) {
      return Y.tabIndex >= 0;
    }), C = r !== void 0 ? G.indexOf(r) : -1, R = o ? G.indexOf(o) : C, g = C >= 0 && R >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      R - C
    ) : (
      // or else measure in focusable space
      N - D
    );
    if (!E && h >= 0 || t.length === 0)
      return h;
    var B = Tt(e, t[0]), W = Tt(e, t[t.length - 1]);
    if (p <= A && y && Math.abs(E) > 1)
      return W;
    if (p >= I && y && Math.abs(E) > 1)
      return B;
    if (E && Math.abs(g) > 1)
      return h;
    if (p <= A)
      return W;
    if (p > I)
      return B;
    if (E)
      return Math.abs(E) > 1 ? h : (i + h + E) % i;
  }
}, Nr = function(e) {
  return function(t) {
    var n, r = (n = un(t)) === null || n === void 0 ? void 0 : n.autofocus;
    return (
      // @ts-expect-error
      t.autofocus || //
      r !== void 0 && r !== "false" || //
      e.indexOf(t) >= 0
    );
  };
}, jt = function(e, t, n) {
  var r = e.map(function(i) {
    var a = i.node;
    return a;
  }), o = At(r.filter(Nr(n)));
  return o && o.length ? It(o) : It(At(t));
}, He = function(e, t) {
  return t === void 0 && (t = []), t.push(e), e.parentNode && He(e.parentNode.host || e.parentNode, t), t;
}, $e = function(e, t) {
  for (var n = He(e), r = He(t), o = 0; o < n.length; o += 1) {
    var i = n[o];
    if (r.indexOf(i) >= 0)
      return i;
  }
  return !1;
}, pn = function(e, t, n) {
  var r = se(e), o = se(t), i = r[0], a = !1;
  return o.filter(Boolean).forEach(function(u) {
    a = $e(a || u, u) || a, n.filter(Boolean).forEach(function(y) {
      var p = $e(i, y);
      p && (!a || ue(p, a) ? a = p : a = $e(p, a));
    });
  }), a;
}, Ct = function(e, t) {
  return e.reduce(function(n, r) {
    return n.concat(Sr(r, t));
  }, []);
}, Mr = function(e, t) {
  var n = /* @__PURE__ */ new Map();
  return t.forEach(function(r) {
    return n.set(r.node, r);
  }), e.map(function(r) {
    return n.get(r);
  }).filter(yr);
}, kr = function(e, t) {
  var n = Oe(se(e).length > 0 ? document : tn(e).ownerDocument), r = ot(e).filter(Qe), o = pn(n || e, e, r), i = /* @__PURE__ */ new Map(), a = Ee(r, i), u = a.filter(function(I) {
    var O = I.node;
    return Qe(O);
  });
  if (u[0]) {
    var y = Ee([o], i).map(function(I) {
      var O = I.node;
      return O;
    }), p = Mr(y, u), m = p.map(function(I) {
      var O = I.node;
      return O;
    }), h = p.filter(function(I) {
      var O = I.tabIndex;
      return O >= 0;
    }).map(function(I) {
      var O = I.node;
      return O;
    }), E = Cr(m, h, y, n, t);
    if (E === Ye) {
      var A = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        jt(a, h, Ct(r, i)) || jt(a, m, Ct(r, i))
      );
      if (A)
        return { node: A };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return E === void 0 ? E : p[E];
  }
}, Dr = function(e) {
  var t = ot(e).filter(Qe), n = pn(e, e, t), r = et(ge([n], !0), !0, !0), o = ge(t, !1);
  return r.map(function(i) {
    var a = i.node, u = i.index;
    return {
      node: a,
      index: u,
      lockItem: o.indexOf(a) >= 0,
      guard: Xe(a)
    };
  });
}, at = function(e, t) {
  e && ("focus" in e && e.focus(t), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, Le = 0, Ge = !1, mn = function(e, t, n) {
  n === void 0 && (n = {});
  var r = kr(e, t);
  if (!Ge && r) {
    if (Le > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), Ge = !0, setTimeout(function() {
        Ge = !1;
      }, 1);
      return;
    }
    Le++, at(r.node, n.focusOptions), Le--;
  }
};
function he(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var t = e ? new WeakRef(e) : null;
  return function() {
    return (t == null ? void 0 : t.deref()) || null;
  };
}
var Rr = function(e) {
  if (!e)
    return null;
  for (var t = [], n = e; n && n !== document.body; )
    t.push({
      current: he(n),
      parent: he(n.parentElement),
      left: he(n.previousElementSibling),
      right: he(n.nextElementSibling)
    }), n = n.parentElement;
  return {
    element: he(e),
    stack: t,
    ownerDocument: e.ownerDocument
  };
}, $r = function(e) {
  var t, n, r, o, i;
  if (e)
    for (var a = e.stack, u = e.ownerDocument, y = /* @__PURE__ */ new Map(), p = 0, m = a; p < m.length; p++) {
      var h = m[p], E = (t = h.parent) === null || t === void 0 ? void 0 : t.call(h);
      if (E && u.contains(E)) {
        for (var A = (n = h.left) === null || n === void 0 ? void 0 : n.call(h), I = h.current(), O = E.contains(I) ? I : void 0, D = (r = h.right) === null || r === void 0 ? void 0 : r.call(h), N = rt([E], y), G = (
          // that is element itself
          (i = (o = O ?? // or something in it's place
          (A == null ? void 0 : A.nextElementSibling)) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            D
          )) !== null && i !== void 0 ? i : (
            // or somebody to the left, something?
            A
          )
        ); G; ) {
          for (var C = 0, R = N; C < R.length; C++) {
            var g = R[C];
            if (G != null && G.contains(g.node))
              return g.node;
          }
          G = G.nextElementSibling;
        }
        if (N.length)
          return N[0].node;
      }
    }
}, vn = function(e) {
  var t = Rr(e);
  return function() {
    return $r(t);
  };
}, Lr = function(e, t, n) {
  if (!e || !t)
    return console.error("no element or scope given"), {};
  var r = se(t);
  if (r.every(function(a) {
    return !ue(a, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = n ? rt(r, /* @__PURE__ */ new Map()) : Ee(r, /* @__PURE__ */ new Map()), i = o.findIndex(function(a) {
    var u = a.node;
    return u === e;
  });
  if (i !== -1)
    return {
      prev: o[i - 1],
      next: o[i + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, Gr = function(e, t) {
  var n = t ? rt(se(e), /* @__PURE__ */ new Map()) : Ee(se(e), /* @__PURE__ */ new Map());
  return {
    first: n[0],
    last: n[n.length - 1]
  };
}, Fr = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, yn = function(e, t, n) {
  t === void 0 && (t = {});
  var r = Fr(t), o = Lr(e, r.scope, r.onlyTabbable);
  if (o) {
    var i = n(o, r.cycle);
    i && at(i.node, r.focusOptions);
  }
}, qr = function(e, t) {
  t === void 0 && (t = {}), yn(e, t, function(n, r) {
    var o = n.next, i = n.first;
    return o || r && i;
  });
}, Vr = function(e, t) {
  t === void 0 && (t = {}), yn(e, t, function(n, r) {
    var o = n.prev, i = n.last;
    return o || r && i;
  });
}, gn = function(e, t, n) {
  var r, o = Gr(e, (r = t.onlyTabbable) !== null && r !== void 0 ? r : !0), i = o[n];
  i && at(i.node, t.focusOptions);
}, zr = function(e, t) {
  t === void 0 && (t = {}), gn(e, t, "first");
}, Ur = function(e, t) {
  t === void 0 && (t = {}), gn(e, t, "last");
};
function ut(e) {
  setTimeout(e, 1);
}
var Wr = function(e) {
  return e && "current" in e ? e.current : e;
}, hn = function() {
  return document && document.activeElement === document.body;
}, Br = function() {
  return hn() || Ir();
}, ve = null, Q = null, Nt = function() {
  return null;
}, ye = null, Se = !1, ct = !1, Qr = function() {
  return !0;
}, Yr = function(e) {
  return (ve.whiteList || Qr)(e);
}, Hr = function(e, t) {
  ye = {
    observerNode: e,
    portaledElement: t
  };
}, Kr = function(e) {
  return ye && ye.portaledElement === e;
};
function Mt(e, t, n, r) {
  var o = null, i = e;
  do {
    var a = r[i];
    if (a.guard)
      a.node.dataset.focusAutoGuard && (o = a);
    else if (a.lockItem) {
      if (i !== e)
        return;
      o = null;
    } else
      break;
  } while ((i += n) !== t);
  o && (o.node.tabIndex = 0);
}
var Jr = function(e) {
  return e ? !!Se : Se === "meanwhile";
}, Zr = function e(t, n, r) {
  return n && (n.host === t && (!n.activeElement || r.contains(n.activeElement)) || n.parentNode && e(t, n.parentNode, r));
}, Xr = function(e, t) {
  return t.some(function(n) {
    return Zr(e, n, n);
  });
}, bn = function(e) {
  return Ee(e, /* @__PURE__ */ new Map());
}, eo = function(e) {
  return !bn([e.parentNode]).some(function(t) {
    return t.node === e;
  });
}, Ie = function() {
  var e = !1;
  if (ve) {
    var t = ve, n = t.observed, r = t.persistentFocus, o = t.autoFocus, i = t.shards, a = t.crossFrame, u = t.focusOptions, y = t.noFocusGuards, p = n || ye && ye.portaledElement;
    if (hn() && Q && Q !== document.body && (!document.body.contains(Q) || eo(Q))) {
      var m = Nt();
      m && m.focus();
    }
    var h = document && document.activeElement;
    if (p) {
      var E = [p].concat(i.map(Wr).filter(Boolean)), A = function() {
        if (!Jr(a) || !y || !Q || ct)
          return !1;
        var N = bn(E), G = N.findIndex(function(C) {
          var R = C.node;
          return R === Q;
        });
        return G === 0 || G === N.length - 1;
      };
      if ((!h || Yr(h)) && (r || A() || !Br() || !Q && o) && (p && !(dn(E) || h && Xr(h, E) || Kr(h)) && (document && !Q && h && !o ? (h.blur && h.blur(), document.body.focus()) : (e = mn(E, Q, {
        focusOptions: u
      }), ye = {})), Q = document && document.activeElement, Q !== document.body && (Nt = vn(Q)), Se = !1), document && h !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var I = document && document.activeElement, O = Dr(E), D = O.map(function(N) {
          var G = N.node;
          return G;
        }).indexOf(I);
        D > -1 && (O.filter(function(N) {
          var G = N.guard, C = N.node;
          return G && C.dataset.focusAutoGuard;
        }).forEach(function(N) {
          var G = N.node;
          return G.removeAttribute("tabIndex");
        }), Mt(D, O.length, 1, O), Mt(D, -1, -1, O));
      }
    }
  }
  return e;
}, wn = function(e) {
  Ie() && e && (e.stopPropagation(), e.preventDefault());
}, st = function() {
  return ut(Ie);
}, to = function(e) {
  var t = e.target, n = e.currentTarget;
  n.contains(t) || Hr(n, t);
}, no = function() {
  return null;
};
process.env.NODE_ENV !== "production" && Ht.node.isRequired;
var En = function() {
  ct = !0;
}, On = function() {
  ct = !1, Se = "just", ut(function() {
    Se = "meanwhile";
  });
}, ro = function() {
  document.addEventListener("focusin", wn), document.addEventListener("focusout", st), window.addEventListener("focus", En), window.addEventListener("blur", On);
}, oo = function() {
  document.removeEventListener("focusin", wn), document.removeEventListener("focusout", st), window.removeEventListener("focus", En), window.removeEventListener("blur", On);
};
function io(e) {
  return e.filter(function(t) {
    var n = t.disabled;
    return !n;
  });
}
var Sn = {
  moveFocusInside: mn,
  focusInside: dn,
  focusNextElement: qr,
  focusPrevElement: Vr,
  focusFirstElement: zr,
  focusLastElement: Ur,
  captureFocusRestore: vn
};
function ao(e) {
  var t = e.slice(-1)[0];
  t && !ve && ro();
  var n = ve, r = n && t && t.id === n.id;
  ve = t, n && !r && (n.onDeactivation(), e.filter(function(o) {
    var i = o.id;
    return i === n.id;
  }).length || n.returnFocus(!t)), t ? (Q = null, (!r || n.observed !== t.observed) && t.onActivation(Sn), Ie(), ut(Ie)) : (oo(), Q = null);
}
Xt.assignSyncMedium(to);
en.assignMedium(st);
er.assignMedium(function(e) {
  return e(Sn);
});
const uo = cr(io, ao)(no);
var co = /* @__PURE__ */ qt(function(e, t) {
  return /* @__PURE__ */ ne.createElement(Ze, be({
    sideCar: uo,
    ref: t
  }, e));
}), _n = Ze.propTypes || {};
_n.sideCar;
var so = Ln(_n, ["sideCar"]);
co.propTypes = process.env.NODE_ENV !== "production" ? so : {};
oe.div`
  width: 1px;
  height: 0px;
  padding: 0;
  overflow: hidden;
  position: fixed;
  top: 1px;
  left: 1px;
`;
const kt = (e, t, n) => {
  if (!Object.prototype.hasOwnProperty.call(e, t))
    return null;
  const r = e[t];
  if (typeof r != "boolean" && !r)
    return null;
  if (Array.isArray(r)) {
    const i = [];
    return r.forEach((a) => {
      i.push(`${t}[]=${a}`);
    }), i.join("&");
  }
  return `${n ? n(t) : t}=${r}`;
}, Do = (e, t = {}) => {
  const { pathParams: n, query: r, filterQuery: o } = t, i = [];
  return n && Object.entries(n).forEach(([a, u]) => {
    if (u === void 0) {
      e = e.replace(new RegExp(`/:${a}\\??`), "");
      return;
    }
    e = e.replace(new RegExp(`:${a}\\??`), String(u));
  }), r && Object.keys(r).forEach((a) => {
    const u = kt(r, a);
    u && i.push(u);
  }), o && Object.keys(o).forEach((a) => {
    const u = kt(
      o,
      a,
      (y) => `filter[${y}]`
    );
    u && i.push(u);
  }), i.length && (e += `?${i.join("&")}`), e;
}, Ro = (e) => e === "Clever District" || e === "Clever Library" ? "Clever" : e === "ClassLink District" ? "ClassLink" : "Manual", fo = 300;
function $o(e, t = fo) {
  let n;
  return (...r) => {
    clearTimeout(n), n = setTimeout(() => {
      e(r);
    }, t);
  };
}
const xn = (e) => e.charAt(0).toUpperCase() + e.slice(1), Lo = (e) => e.split("_").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(""), Go = (e) => e.split("_").map((t, n) => n === 0 ? t : xn(t)).join(""), Fo = (e) => e.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase(), qo = (e) => e.split("-").map((t, n) => n === 0 ? t : xn(t)).join("");
let lo = (e) => crypto.getRandomValues(new Uint8Array(e)), po = (e, t, n) => {
  let r = (2 << Math.log(e.length - 1) / Math.LN2) - 1, o = -~(1.6 * r * t / e.length);
  return (i = t) => {
    let a = "";
    for (; ; ) {
      let u = n(o), y = o | 0;
      for (; y--; )
        if (a += e[u[y] & r] || "", a.length === i) return a;
    }
  };
}, mo = (e, t = 21) => po(e, t, lo);
const vo = mo("1234567890abcdef", 14), Pn = (e) => {
  if (!e) throw new Error("Application name is required");
  return `${e}-${vo()}`;
}, Vo = () => Pn(ft.e4), zo = () => Pn(ft.seasons);
var ft = /* @__PURE__ */ ((e) => (e.e4 = "elements", e.seasons = "ke", e))(ft || {}), Fe = {}, qe = {}, Ve = {}, Dt;
function yo() {
  return Dt || (Dt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = function() {
      for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
        i[a] = arguments[a];
      if (typeof window < "u") {
        var u;
        typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
          window.dataLayer.push(arguments);
        }), (u = window).gtag.apply(u, i);
      }
    }, n = t;
    e.default = n;
  }(Ve)), Ve;
}
var ze = {}, Rt;
function go() {
  return Rt || (Rt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var t = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
    function n(u) {
      return u.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(y, p, m) {
        return p > 0 && p + y.length !== m.length && y.search(t) > -1 && m.charAt(p - 2) !== ":" && (m.charAt(p + y.length) !== "-" || m.charAt(p - 1) === "-") && m.charAt(p - 1).search(/[^\s-]/) < 0 ? y.toLowerCase() : y.substr(1).search(/[A-Z]|\../) > -1 ? y : y.charAt(0).toUpperCase() + y.substr(1);
      });
    }
    function r(u) {
      return typeof u == "string" && u.indexOf("@") !== -1;
    }
    var o = "REDACTED (Potential Email Address)";
    function i(u) {
      return r(u) ? (console.warn("This arg looks like an email address, redacting."), o) : u;
    }
    function a() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, m = u || "";
      return y && (m = n(u)), p && (m = i(m)), m;
    }
  }(ze)), ze;
}
var $t;
function ho() {
  return $t || ($t = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = e.GA4 = void 0;
    var t = a(yo()), n = a(go()), r = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"], o = ["title", "location"], i = ["page", "hitType"];
    function a(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function u(d, c) {
      if (d == null) return {};
      var s = y(d, c), l, b;
      if (Object.getOwnPropertySymbols) {
        var S = Object.getOwnPropertySymbols(d);
        for (b = 0; b < S.length; b++)
          l = S[b], !(c.indexOf(l) >= 0) && Object.prototype.propertyIsEnumerable.call(d, l) && (s[l] = d[l]);
      }
      return s;
    }
    function y(d, c) {
      if (d == null) return {};
      var s = {}, l = Object.keys(d), b, S;
      for (S = 0; S < l.length; S++)
        b = l[S], !(c.indexOf(b) >= 0) && (s[b] = d[b]);
      return s;
    }
    function p(d) {
      "@babel/helpers - typeof";
      return p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(c) {
        return typeof c;
      } : function(c) {
        return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
      }, p(d);
    }
    function m(d) {
      return A(d) || E(d) || G(d) || h();
    }
    function h() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function E(d) {
      if (typeof Symbol < "u" && d[Symbol.iterator] != null || d["@@iterator"] != null) return Array.from(d);
    }
    function A(d) {
      if (Array.isArray(d)) return C(d);
    }
    function I(d, c) {
      var s = Object.keys(d);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(d);
        c && (l = l.filter(function(b) {
          return Object.getOwnPropertyDescriptor(d, b).enumerable;
        })), s.push.apply(s, l);
      }
      return s;
    }
    function O(d) {
      for (var c = 1; c < arguments.length; c++) {
        var s = arguments[c] != null ? arguments[c] : {};
        c % 2 ? I(Object(s), !0).forEach(function(l) {
          L(d, l, s[l]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(s)) : I(Object(s)).forEach(function(l) {
          Object.defineProperty(d, l, Object.getOwnPropertyDescriptor(s, l));
        });
      }
      return d;
    }
    function D(d, c) {
      return g(d) || R(d, c) || G(d, c) || N();
    }
    function N() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function G(d, c) {
      if (d) {
        if (typeof d == "string") return C(d, c);
        var s = Object.prototype.toString.call(d).slice(8, -1);
        if (s === "Object" && d.constructor && (s = d.constructor.name), s === "Map" || s === "Set") return Array.from(d);
        if (s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s)) return C(d, c);
      }
    }
    function C(d, c) {
      (c == null || c > d.length) && (c = d.length);
      for (var s = 0, l = new Array(c); s < c; s++) l[s] = d[s];
      return l;
    }
    function R(d, c) {
      var s = d == null ? null : typeof Symbol < "u" && d[Symbol.iterator] || d["@@iterator"];
      if (s != null) {
        var l, b, S, f, v = [], _ = !0, P = !1;
        try {
          if (S = (s = s.call(d)).next, c !== 0) for (; !(_ = (l = S.call(s)).done) && (v.push(l.value), v.length !== c); _ = !0) ;
        } catch (x) {
          P = !0, b = x;
        } finally {
          try {
            if (!_ && s.return != null && (f = s.return(), Object(f) !== f)) return;
          } finally {
            if (P) throw b;
          }
        }
        return v;
      }
    }
    function g(d) {
      if (Array.isArray(d)) return d;
    }
    function B(d, c) {
      if (!(d instanceof c))
        throw new TypeError("Cannot call a class as a function");
    }
    function W(d, c) {
      for (var s = 0; s < c.length; s++) {
        var l = c[s];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(d, H(l.key), l);
      }
    }
    function Y(d, c, s) {
      return c && W(d.prototype, c), Object.defineProperty(d, "prototype", { writable: !1 }), d;
    }
    function L(d, c, s) {
      return c = H(c), c in d ? Object.defineProperty(d, c, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : d[c] = s, d;
    }
    function H(d) {
      var c = ee(d, "string");
      return p(c) === "symbol" ? c : String(c);
    }
    function ee(d, c) {
      if (p(d) !== "object" || d === null) return d;
      var s = d[Symbol.toPrimitive];
      if (s !== void 0) {
        var l = s.call(d, c);
        if (p(l) !== "object") return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (c === "string" ? String : Number)(d);
    }
    var J = /* @__PURE__ */ function() {
      function d() {
        var c = this;
        B(this, d), L(this, "reset", function() {
          c.isInitialized = !1, c._testMode = !1, c._currentMeasurementId, c._hasLoadedGA = !1, c._isQueuing = !1, c._queueGtag = [];
        }), L(this, "_gtag", function() {
          for (var s = arguments.length, l = new Array(s), b = 0; b < s; b++)
            l[b] = arguments[b];
          c._testMode || c._isQueuing ? c._queueGtag.push(l) : t.default.apply(void 0, l);
        }), L(this, "_loadGA", function(s, l) {
          var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
          if (!(typeof window > "u" || typeof document > "u") && !c._hasLoadedGA) {
            var S = document.createElement("script");
            S.async = !0, S.src = "".concat(b, "?id=").concat(s), l && S.setAttribute("nonce", l), document.body.appendChild(S), window.dataLayer = window.dataLayer || [], window.gtag = function() {
              window.dataLayer.push(arguments);
            }, c._hasLoadedGA = !0;
          }
        }), L(this, "_toGtagOptions", function(s) {
          if (s) {
            var l = {
              // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
              // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
              cookieUpdate: "cookie_update",
              cookieExpires: "cookie_expires",
              cookieDomain: "cookie_domain",
              cookieFlags: "cookie_flags",
              // must be in set method?
              userId: "user_id",
              clientId: "client_id",
              anonymizeIp: "anonymize_ip",
              // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
              contentGroup1: "content_group1",
              contentGroup2: "content_group2",
              contentGroup3: "content_group3",
              contentGroup4: "content_group4",
              contentGroup5: "content_group5",
              // https://support.google.com/analytics/answer/9050852?hl=en
              allowAdFeatures: "allow_google_signals",
              allowAdPersonalizationSignals: "allow_ad_personalization_signals",
              nonInteraction: "non_interaction",
              page: "page_path",
              hitCallback: "event_callback"
            }, b = Object.entries(s).reduce(function(S, f) {
              var v = D(f, 2), _ = v[0], P = v[1];
              return l[_] ? S[l[_]] = P : S[_] = P, S;
            }, {});
            return b;
          }
        }), L(this, "initialize", function(s) {
          var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if (!s)
            throw new Error("Require GA_MEASUREMENT_ID");
          var b = typeof s == "string" ? [{
            trackingId: s
          }] : s;
          c._currentMeasurementId = b[0].trackingId;
          var S = l.gaOptions, f = l.gtagOptions, v = l.nonce, _ = l.testMode, P = _ === void 0 ? !1 : _, x = l.gtagUrl;
          if (c._testMode = P, P || c._loadGA(c._currentMeasurementId, v, x), c.isInitialized || (c._gtag("js", /* @__PURE__ */ new Date()), b.forEach(function(T) {
            var k = O(O(O({}, c._toGtagOptions(O(O({}, S), T.gaOptions))), f), T.gtagOptions);
            Object.keys(k).length ? c._gtag("config", T.trackingId, k) : c._gtag("config", T.trackingId);
          })), c.isInitialized = !0, !P) {
            var M = m(c._queueGtag);
            for (c._queueGtag = [], c._isQueuing = !1; M.length; ) {
              var j = M.shift();
              c._gtag.apply(c, m(j)), j[0] === "get" && (c._isQueuing = !0);
            }
          }
        }), L(this, "set", function(s) {
          if (!s) {
            console.warn("`fieldsObject` is required in .set()");
            return;
          }
          if (p(s) !== "object") {
            console.warn("Expected `fieldsObject` arg to be an Object");
            return;
          }
          Object.keys(s).length === 0 && console.warn("empty `fieldsObject` given to .set()"), c._gaCommand("set", s);
        }), L(this, "_gaCommandSendEvent", function(s, l, b, S, f) {
          c._gtag("event", l, O(O({
            event_category: s,
            event_label: b,
            value: S
          }, f && {
            non_interaction: f.nonInteraction
          }), c._toGtagOptions(f)));
        }), L(this, "_gaCommandSendEventParameters", function() {
          for (var s = arguments.length, l = new Array(s), b = 0; b < s; b++)
            l[b] = arguments[b];
          if (typeof l[0] == "string")
            c._gaCommandSendEvent.apply(c, m(l.slice(1)));
          else {
            var S = l[0], f = S.eventCategory, v = S.eventAction, _ = S.eventLabel, P = S.eventValue;
            S.hitType;
            var x = u(S, r);
            c._gaCommandSendEvent(f, v, _, P, x);
          }
        }), L(this, "_gaCommandSendTiming", function(s, l, b, S) {
          c._gtag("event", "timing_complete", {
            name: l,
            value: b,
            event_category: s,
            event_label: S
          });
        }), L(this, "_gaCommandSendPageview", function(s, l) {
          if (l && Object.keys(l).length) {
            var b = c._toGtagOptions(l), S = b.title, f = b.location, v = u(b, o);
            c._gtag("event", "page_view", O(O(O(O({}, s && {
              page_path: s
            }), S && {
              page_title: S
            }), f && {
              page_location: f
            }), v));
          } else s ? c._gtag("event", "page_view", {
            page_path: s
          }) : c._gtag("event", "page_view");
        }), L(this, "_gaCommandSendPageviewParameters", function() {
          for (var s = arguments.length, l = new Array(s), b = 0; b < s; b++)
            l[b] = arguments[b];
          if (typeof l[0] == "string")
            c._gaCommandSendPageview.apply(c, m(l.slice(1)));
          else {
            var S = l[0], f = S.page;
            S.hitType;
            var v = u(S, i);
            c._gaCommandSendPageview(f, v);
          }
        }), L(this, "_gaCommandSend", function() {
          for (var s = arguments.length, l = new Array(s), b = 0; b < s; b++)
            l[b] = arguments[b];
          var S = typeof l[0] == "string" ? l[0] : l[0].hitType;
          switch (S) {
            case "event":
              c._gaCommandSendEventParameters.apply(c, l);
              break;
            case "pageview":
              c._gaCommandSendPageviewParameters.apply(c, l);
              break;
            case "timing":
              c._gaCommandSendTiming.apply(c, m(l.slice(1)));
              break;
            case "screenview":
            case "transaction":
            case "item":
            case "social":
            case "exception":
              console.warn("Unsupported send command: ".concat(S));
              break;
            default:
              console.warn("Send command doesn't exist: ".concat(S));
          }
        }), L(this, "_gaCommandSet", function() {
          for (var s = arguments.length, l = new Array(s), b = 0; b < s; b++)
            l[b] = arguments[b];
          typeof l[0] == "string" && (l[0] = L({}, l[0], l[1])), c._gtag("set", c._toGtagOptions(l[0]));
        }), L(this, "_gaCommand", function(s) {
          for (var l = arguments.length, b = new Array(l > 1 ? l - 1 : 0), S = 1; S < l; S++)
            b[S - 1] = arguments[S];
          switch (s) {
            case "send":
              c._gaCommandSend.apply(c, b);
              break;
            case "set":
              c._gaCommandSet.apply(c, b);
              break;
            default:
              console.warn("Command doesn't exist: ".concat(s));
          }
        }), L(this, "ga", function() {
          for (var s = arguments.length, l = new Array(s), b = 0; b < s; b++)
            l[b] = arguments[b];
          if (typeof l[0] == "string")
            c._gaCommand.apply(c, l);
          else {
            var S = l[0];
            c._gtag("get", c._currentMeasurementId, "client_id", function(f) {
              c._isQueuing = !1;
              var v = c._queueGtag;
              for (S({
                get: function(x) {
                  return x === "clientId" ? f : x === "trackingId" ? c._currentMeasurementId : x === "apiVersion" ? "1" : void 0;
                }
              }); v.length; ) {
                var _ = v.shift();
                c._gtag.apply(c, m(_));
              }
            }), c._isQueuing = !0;
          }
          return c.ga;
        }), L(this, "event", function(s, l) {
          if (typeof s == "string")
            c._gtag("event", s, c._toGtagOptions(l));
          else {
            var b = s.action, S = s.category, f = s.label, v = s.value, _ = s.nonInteraction, P = s.transport;
            if (!S || !b) {
              console.warn("args.category AND args.action are required in event()");
              return;
            }
            var x = {
              hitType: "event",
              eventCategory: (0, n.default)(S),
              eventAction: (0, n.default)(b)
            };
            f && (x.eventLabel = (0, n.default)(f)), typeof v < "u" && (typeof v != "number" ? console.warn("Expected `args.value` arg to be a Number.") : x.eventValue = v), typeof _ < "u" && (typeof _ != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : x.nonInteraction = _), typeof P < "u" && (typeof P != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(P) === -1 && console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"), x.transport = P)), c._gaCommand("send", x);
          }
        }), L(this, "send", function(s) {
          c._gaCommand("send", s);
        }), this.reset();
      }
      return Y(d, [{
        key: "gtag",
        value: function() {
          this._gtag.apply(this, arguments);
        }
      }]), d;
    }();
    e.GA4 = J;
    var re = new J();
    e.default = re;
  }(qe)), qe;
}
var Lt;
function bo() {
  return Lt || (Lt = 1, function(e) {
    function t(u) {
      "@babel/helpers - typeof";
      return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
        return typeof y;
      } : function(y) {
        return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
      }, t(u);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = e.ReactGAImplementation = void 0;
    var n = o(ho());
    function r(u) {
      if (typeof WeakMap != "function") return null;
      var y = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap();
      return (r = function(h) {
        return h ? p : y;
      })(u);
    }
    function o(u, y) {
      if (u && u.__esModule)
        return u;
      if (u === null || t(u) !== "object" && typeof u != "function")
        return { default: u };
      var p = r(y);
      if (p && p.has(u))
        return p.get(u);
      var m = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in u)
        if (E !== "default" && Object.prototype.hasOwnProperty.call(u, E)) {
          var A = h ? Object.getOwnPropertyDescriptor(u, E) : null;
          A && (A.get || A.set) ? Object.defineProperty(m, E, A) : m[E] = u[E];
        }
      return m.default = u, p && p.set(u, m), m;
    }
    var i = n.GA4;
    e.ReactGAImplementation = i;
    var a = n.default;
    e.default = a;
  }(Fe)), Fe;
}
var wo = bo();
const Eo = ({
  id: e,
  type: t,
  language: n,
  fullName: r,
  groupId: o,
  gaUserId: i,
  teacherId: a,
  email: u,
  emailDomain: y,
  gradeShortName: p,
  ownerInitials: m,
  superuserPretendMode: h,
  accountType: E
}) => ({
  type: t,
  id: e,
  clientId: Oo(),
  fullName: r,
  groupId: o,
  gaUserId: i,
  teacherId: a,
  pretendMode: h,
  language: n,
  emailDomain: y,
  gradeShortName: p,
  ownerInitials: m,
  email: u,
  accountType: E
}), Gt = (e, ...t) => {
  let n = { gaOptions: {} };
  return t.forEach((r) => {
    n = {
      ...n,
      ...r,
      gaOptions: {
        ...n == null ? void 0 : n.gaOptions,
        ...r == null ? void 0 : r.gaOptions,
        userId: e == null ? void 0 : e.gaUserId
      }
    };
  }), n;
}, Oo = () => {
  var e;
  return (e = document.cookie.split(";").find((t) => t.trim().startsWith("_ga="))) == null ? void 0 : e.split("=")[1].substring(6);
}, So = (e) => ({
  gaOptions: {
    user_properties: {
      cd1: e.gaUserId,
      cd9: e.clientId,
      cd11: e.accountType
    }
  }
}), _o = "";
class xo extends wo.ReactGAImplementation {
  constructor() {
    super(...arguments);
    dt(this, "config");
  }
  async init(n, r) {
    if (!n) throw new Error("Require GA_MEASUREMENT_ID");
    const o = await fetch(`${_o}/api/auth`);
    if (!o.ok) return !1;
    const i = await o.json();
    if (this.config = Eo(i), this.isPretendMode)
      return console.debug("GA is disabled due to pretend mode."), !1;
    let a;
    const u = So(this.config);
    return typeof r == "object" ? a = Gt(this.config, u, r) : a = Gt(
      this.config,
      u,
      r == null ? void 0 : r(this.config)
    ), this.initialize(n, a), this.isInitialized || console.error("GA initialized with an error"), this.isInitialized;
  }
  get isInit() {
    return this.isInitialized;
  }
  sendEvent(n, r) {
    (typeof n == "string" || Po(n)) && this.event(n, r);
  }
  setDimension(n) {
    const r = new Map(Object.entries(n));
    this.setDimensions(r);
  }
  setDimensions(n) {
    this.gtag("set", "user_properties", Object.fromEntries(n));
  }
  sendEventAsSupervizor(n, r) {
    var o;
    ((o = this.config) == null ? void 0 : o.type) === "Supervizor" && this.sendEvent(n, r);
  }
  sendEventAsTeacher(n, r) {
    var o;
    ((o = this.config) == null ? void 0 : o.type) === "Teacher" && this.sendEvent(n, r);
  }
  get isPretendMode() {
    var n;
    return !!((n = this.config) != null && n.pretendMode);
  }
  pageView(n) {
    this.isInit && this.send({ hitType: "pageview", page: n });
  }
}
const Ft = new xo();
function Po(e) {
  const t = e;
  return !!(t.action && t.category);
}
let Pe;
const Uo = (e, t) => {
  const [n, r] = ae(), o = me(!0);
  if (!Pe && !e)
    throw new Error(
      "You must provide Google analytics ID in first invocation of useGA."
    );
  return ce(() => {
    async function i() {
      !Pe && e && (Pe = Ft.init(e, t)), await Pe, o.current && r(Ft);
    }
    i();
  }, [e, t]), ce(() => () => {
    o.current = !1;
  }, []), n;
};
export {
  ft as ApplicationName,
  Do as buildURI,
  Fo as camelToSnake,
  xn as capitalize,
  $o as debounce,
  Vo as getElementsErrorId,
  Ro as getPlainRosterType,
  zo as getSeasonsErrorId,
  qo as kebabToCamel,
  Go as snakeToCamel,
  Lo as snakeToPascal,
  Co as useFetch,
  Uo as useGoogleAnalytics,
  Dn as useLazyFetch,
  Mo as useOutside,
  No as useToggle,
  ko as useWindowSize
};
